import React from "react";
import { Heart } from "lucide-react";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      className="w-full py-10 px-6 text-center"
      style={{
        backgroundColor: "var(--bg-primary)",
        borderTop: "1px solid var(--border-soft)",
      }}
      data-testid="site-footer"
    >
      <p
        className="font-script text-xl"
        style={{ color: "var(--text-accent)" }}
      >
        handmade with love, one stitch at a time
      </p>
      <p
        className="mt-2 text-sm flex items-center justify-center gap-1.5"
        style={{ color: "var(--text-secondary)" }}
      >
        © {year} The Giving Stitch
        <Heart size={14} fill="currentColor" style={{ color: "var(--brand-rose)" }} />
      </p>
    </footer>
  );
};

export default Footer;
